export default __webpack_public_path__ + "static/media/Vincent_Van_Gogh_Mandorlo_in_fiore_Red_variation_35_x_70_cm.9fbc4c3a.jpg";